import { decode } from 'base64-arraybuffer'

import { base64UrlToBase64 } from '@cash-web/shared/util-encoding'

export function decodeOptions(options?: string) {
  const jsonOptions = options ? JSON.parse(options) : {}

  const decodedChallenge = decode(base64UrlToBase64(jsonOptions.challenge))
  const decodedUser = {
    ...jsonOptions.user,
    id: decode(base64UrlToBase64(jsonOptions.user.id)),
  }
  const decodedExcludeCredentials =
    jsonOptions.excludeCredentials.map((cred: { type: PublicKeyCredentialType; id: string }) => {
      return { type: cred.type, id: decode(base64UrlToBase64(cred.id)) }
    }) || []

  const decodedOptions: PublicKeyCredentialCreationOptions = {
    ...jsonOptions,
    challenge: decodedChallenge,
    user: decodedUser,
    excludeCredentials: decodedExcludeCredentials,
  }
  return decodedOptions
}
